module.exports = __webpack_public_path__ + "img/illustration_send_email.8075a8de.png";